import {
    IMPORT_OUTSOURCE_UPDATE,
    IMPORT_OUTSOURCES_ERROR,
    IMPORT_OUTSOURCES_LOADING,
    IMPORT_OUTSOURCES_UPDATE,
    SEARCH_OUTSOURCE_ERROR,
    SEARCH_OUTSOURCE_LOADING,
    SEARCH_OUTSOURCE_UPDATE,
} from '../actions/importOutsourceActions';

const INITIAL_STATE = {
    importOutsources: [],
    importOutsourcesPagination: null,
    importOutsourcesLoading: false,
    importOutsourcesError: null,
    importOutsource: null,

    searchOutsource: null,
    searchOutsourceLoading: false,
    searchOutsourceError: null,
};

export default (state = INITIAL_STATE, action) => {
    switch ( action.type ) {
        case IMPORT_OUTSOURCES_UPDATE:
            return {
                ...state,
                importOutsources: action.payload.data,
                importOutsourcesPagination: action.payload.pagination,
                importOutsourcesError: action.payload.message,
            };
        case IMPORT_OUTSOURCES_ERROR:
            return {
                ...state,
                importOutsourcesError: action.payload,
            };
        case IMPORT_OUTSOURCES_LOADING:
            return { ...state, importOutsourcesLoading: action.payload };
        case IMPORT_OUTSOURCE_UPDATE:
            return { ...state, importOutsource: action.payload };

        case SEARCH_OUTSOURCE_UPDATE:
            return {
                ...state,
                searchOutsource: action.payload,
                searchOutsourceError: '',
            };
        case SEARCH_OUTSOURCE_ERROR:
            return {
                ...state,
                searchOutsourceError: action.payload,
            };
        case SEARCH_OUTSOURCE_LOADING:
            return {
                ...state,
                searchOutsourceLoading: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/outsource/reducers/ImportOutsourcesReducer.js